import { Props } from './types'
import Core from './Core'
import { BooleanSelection as BooleanSelectionType } from '../../../../../types/Survey/Element'
import { BooleanSelection as BooleanSelectionAnswerType } from '../../../../../types/Survey/Answer/Element'
import Button from '../../../../UI/Button/Button'

const BooleanSelection: React.FC<Props<BooleanSelectionType, BooleanSelectionAnswerType>> = ({ element, answerElement, updateElement }) => {
  const update = (selectionValue: 'yes' | 'no') => () => {
    updateElement({ ...answerElement, selectionValue })
  }

  return (
    <div>
      <Core element={element} />
      <div className="flex flex-row justify-around gap-10 mt-5">
        <Button contrast={answerElement.selectionValue === 'yes'} onClick={update('yes')} className="w-[150px]" text={element.yesLabel} />
        <Button contrast={answerElement.selectionValue === 'no'} onClick={update('no')} className="w-[150px]" text={element.noLabel} />
      </div>
    </div>
  )
}

export default BooleanSelection
